import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { initialAsyncReduxState } from '../../constants';
import { Education } from '../../models/@competentNL/Educations/Educations';
import { Occupation } from '../../models/@competentNL/Occupations/Occupations';
import { Skill, SkillBase } from '../../models/@competentNL/Skills/Skills';
import { AsyncReduxState } from '../../types';

// TODO: Split up in separate Slices when everything is converted to CompetentNL
export type CompetentNLState = AsyncReduxState<{
    occupationsIsLoading: boolean;
    occupationsError: string;
    occupations: Occupation[];
    occupation?: Occupation;
    educationsIsLoading: boolean;
    educationsError: string;
    educations: Education[];
    education?: Education;
    skillsIsLoading: boolean;
    skillsIsSuccessful: boolean;
    skillsError: string;
    skillBases: SkillBase[];
    skill?: Skill;
}>;

const initialState: CompetentNLState = {
    ...initialAsyncReduxState,
    occupationsIsLoading: false,
    occupationsError: '',
    occupations: [],
    educationsIsLoading: false,
    educationsError: '',
    educations: [],
    skillsIsLoading: false,
    skillsIsSuccessful: false,
    skillsError: '',
    skillBases: [],
};

export const competentNLSlice = createSlice({
    name: 'competentNLReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): CompetentNLState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): CompetentNLState {
            return {
                ...state,
                error: action.payload,
            };
        },
        setOccupationsIsLoading(state, action: PayloadAction<boolean>): CompetentNLState {
            return {
                ...state,
                occupationsIsLoading: action.payload,
            };
        },
        setOccupationsError(state, action: PayloadAction<string>): CompetentNLState {
            return {
                ...state,
                occupationsError: action.payload,
            };
        },
        setOccupations(state, action: PayloadAction<Occupation[]>): CompetentNLState {
            return {
                ...state,
                occupations: action.payload,
            };
        },
        setOccupation(state, action: PayloadAction<Occupation | undefined>): CompetentNLState {
            return {
                ...state,
                occupation: action.payload,
            };
        },
        setEducationsIsLoading(state, action: PayloadAction<boolean>): CompetentNLState {
            return {
                ...state,
                educationsIsLoading: action.payload,
            };
        },
        setEducationsError(state, action: PayloadAction<string>): CompetentNLState {
            return {
                ...state,
                educationsError: action.payload,
            };
        },
        setEducations(state, action: PayloadAction<Education[]>): CompetentNLState {
            return {
                ...state,
                educations: action.payload,
            };
        },
        setEducation(state, action: PayloadAction<Education | undefined>): CompetentNLState {
            return {
                ...state,
                education: action.payload,
            };
        },
        setSkillsIsLoading(state, action: PayloadAction<boolean>): CompetentNLState {
            return {
                ...state,
                skillsIsLoading: action.payload,
            };
        },
        setSkillsIsSuccessful(state, action: PayloadAction<boolean>): CompetentNLState {
            return {
                ...state,
                skillsIsSuccessful: action.payload,
            };
        },
        setSkillsError(state, action: PayloadAction<string>): CompetentNLState {
            return {
                ...state,
                skillsError: action.payload,
            };
        },
        setSkillBases(state, action: PayloadAction<SkillBase[]>): CompetentNLState {
            return {
                ...state,
                skillBases: action.payload,
            };
        },
        setSkill(state, action: PayloadAction<Skill | undefined>): CompetentNLState {
            return {
                ...state,
                skill: action.payload,
            };
        },
    },
});

export const {
    setIsLoading,
    setError,
    setOccupationsIsLoading,
    setOccupationsError,
    setOccupations,
    setOccupation,
    setEducationsIsLoading,
    setEducationsError,
    setEducations,
    setEducation,
    setSkillsIsLoading,
    setSkillsIsSuccessful,
    setSkillsError,
    setSkillBases,
    setSkill,
} = competentNLSlice.actions;

export default competentNLSlice.reducer;
